const STORAGE_KEY = 'postLoginRedirect';

export const getCurrentPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const rememberRedirectPath = (path) => {
  if (!path) return;
  try {
    localStorage.setItem(STORAGE_KEY, path);
  } catch (err) {
    // ignore storage failures
  }
};

export const consumeRedirectPath = (fallback = '/') => {
  try {
    const path = localStorage.getItem(STORAGE_KEY);
    if (path) {
      localStorage.removeItem(STORAGE_KEY);
      return path;
    }
  } catch (err) {
    // ignore
  }
  return fallback;
};

export const redirectToLogin = (navigate, path) => {
  const target = path || getCurrentPath();
  rememberRedirectPath(target);
  navigate('/login', { replace: false });
};
